module.exports = __webpack_public_path__ + "acorn.9b64cd95cbe750f038aff4b045a31265.svg";